import { get } from "../utility/fetch-util";

/**
 * Get the contracts for the signed in user
 */
export const getContracts = async (progress) => {
    return get('/api/drivers/contract', null, progress);
}
